import React, { Component } from 'react'

import TestVehicleDiscount from './TestVehicleDiscount'
import HelperCollections from '../../helpers/HelperCollections';
import IconRender from '../std/IconRender';
import ContMessageI18N from '../../containers/ContMessageI18N';

class TestVehicleDiscounts extends Component {

	render() {
		return (
			<div className="row border">
				<p><ContMessageI18N i18n='vehicle.discountsSpec' /></p>
				{this.props.data && this.props.data.map((occurence, index) => (
					<div key={index} className="row">
						<TestVehicleDiscount data={occurence} settings={this.props.settings}
							onChange={(data) => { HelperCollections.handleChange(data, index, this.props) }} />
						<div className="col-auto">
							<button className="btn btn-light" onClick={() => HelperCollections.handleDelete(occurence.code, 'code', this.props)} >
								<IconRender name="trash" />
							</button>
						</div>
						<div className="col-auto">
							<button className="btn btn-light" onClick={() => HelperCollections.handleCopy(occurence.code, 'code', this.props)} >
								<IconRender name="stickies" />
							</button>
						</div>
					</div>
				))}
				<div className="col-auto">
					<button className="btn btn-light" onClick={() => HelperCollections.handleAdd('code', this.props)} >
						<IconRender name="plus" />
					</button>
				</div>
			</div>
		)
	}
}

export default (TestVehicleDiscounts)
